import './calendar.scss';
import Pikaday from 'pikaday';
import { createUrlQueryString, decodeUrlQueryString } from 'js-api'; ////////// Setup

document.addEventListener('turboujs:load', function (_event) {
  document.querySelectorAll('[data-calendar]').forEach(function (calendar) {
    setupCalendar(calendar);
  });
});
document.addEventListener('popover:display', function (event) {
  var popover = event.detail;
  popover.querySelectorAll('[data-calendar]').forEach(function (calendar) {
    setupCalendar(calendar);
  });
});

function setupCalendar(calendar) {
  calendar.picker = createPicker(calendar);
  calendar.innerHTML = '';
  calendar.appendChild(calendar.picker.el);

  if (calendar.picker.content) {
    calendar.appendChild(calendar.picker.content);
  }
} ////////// Picker


function createPicker(calendar) {
  var updateQuery = calendar.getBooleanAttribute('data-calendar-update-query');
  var updateQueryAttribute = calendar.getAttribute('data-calendar-update-query') || 'date';
  var updateUrl = calendar.getBooleanAttribute('data-calendar-update-url');
  var updateHref = calendar.getAttribute('data-calendar-href');
  var monthOnly = calendar.getBooleanAttribute('data-calendar-month');
  var options = {
    showDaysInNextAndPreviousMonths: true,
    keyboardInput: false,
    onSelect: function onSelect(date) {
      if (updateQuery) {
        updateQueryString(calendar, date, updateQueryAttribute);
      } else if (updateUrl) {
        updateDateUrl(calendar, date);
      } else if (updateHref) {
        updateDateHref(calendar, date, updateHref);
      }
    },
    onDraw: function onDraw(picker) {
      if (monthOnly) {
        var date = picker.getDate();

        if (!date) {
          return;
        }

        var currentDateParam = date.toISOMonthString();
        var cal = picker.calendars[0];
        var showingDateParam = "".concat(cal.year.toString().padStart(4, '0'), "-").concat((cal.month + 1).toString().padStart(2, '0'));
        var anchor = calendar.querySelector('.pika-choose');

        if (anchor) {
          if (currentDateParam == showingDateParam) {
            anchor.classList.add('pika-choose--hidden');
          } else {
            anchor.classList.remove('pika-choose--hidden');
          }
        }
      }
    }
  };
  options.minDate = calendar.getDateAttribute('data-calendar-min');
  options.maxDate = calendar.getDateAttribute('data-calendar-max');
  var picker = new Pikaday(options);
  var selectedDate = calendar.getDateAttribute('data-calendar');

  if (selectedDate) {
    picker.setDate(selectedDate, true);
  }

  if (monthOnly) {
    picker.el.classList.add('pika-single--month');
    var anchor = document.createElement('a');
    anchor.innerHTML = 'Choose';
    anchor.addEventListener('click', function (_event) {
      var cal = picker.calendars[0];
      var showingDateParam = "".concat(cal.year.toString().padStart(4, '0'), "-").concat((cal.month + 1).toString().padStart(2, '0'));
      updateDateStringUrl(calendar, showingDateParam);
    });
    var item = document.createElement('li');
    item.classList.add('dropdown__menu__item');
    item.appendChild(anchor);
    var list = document.createElement('ul');
    list.className = 'dropdown__menu__list pika-choose pika-choose--hidden';
    list.appendChild(item);
    picker.content = list;
  }

  return picker;
} //////////


function updateQueryString(calendar, date, attribute) {
  var popover = calendar.closest('pop-over');

  var parser = _calendarUrlParser(calendar, popover);

  var query = parser.search.replace(/^\?/, '');
  var queryObject = decodeUrlQueryString(query);
  queryObject[attribute] = date.toISODateString();

  if (queryObject['inject_children']) {
    queryObject['inject_children'] = queryObject['inject_children'][''];
  }

  query = createUrlQueryString(queryObject);
  parser.search = "?".concat(query);

  _calendarUpdateUrl(calendar, popover, parser);
}

function updateDateUrl(calendar, date) {
  updateDateStringUrl(calendar, date.toISODateString());
}

function updateDateStringUrl(calendar, string) {
  var popover = calendar.closest('pop-over');

  var parser = _calendarUrlParser(calendar, popover);

  var regex = /\/(\d{4}-\d{2}(-\d{2})?)?$/;

  if (parser.pathname.match(regex)) {
    parser.pathname = parser.pathname.replace(/\/(\d{4}-\d{2}(-\d{2})?)?$/, "/".concat(string));
  } else {
    parser.pathname = "".concat(parser.pathname, "/").concat(string);
  }

  _calendarUpdateUrl(calendar, popover, parser);
}

function updateDateHref(calendar, date, href) {
  updateDateStringHref(calendar, date.toISODateString(), href);
}

function updateDateStringHref(calendar, string, href) {
  var parser = document.createElement('a');
  parser.href = href;
  var popover = calendar.closest('pop-over');
  var regex = /\/(\d{4}-\d{2}(-\d{2})?)?$/;

  if (parser.pathname.match(regex)) {
    parser.pathname = parser.pathname.replace(/\/(\d{4}-\d{2}(-\d{2})?)?$/, "/".concat(string));
  } else {
    parser.pathname = "".concat(parser.pathname, "/").concat(string);
  }

  _calendarUpdateUrl(calendar, popover, parser);
}

function _calendarUrlParser(calendar, popover) {
  var url = window.location.toString();

  if (popover && popover.currentUrl) {
    url = popover.currentUrl;
  }

  var parser = document.createElement('a');
  parser.href = url;
  return parser;
}

function _calendarUpdateUrl(calendar, popover, parser) {
  if (popover && popover.currentUrl) {
    popover.loadContent(parser.href);
  } else {
    window.Turbolinks.visit(parser.href);
  }
}